import { Component, Input,ElementRef, HostListener, } from '@angular/core';

@Component({
  selector: 'app-widget-stats',
  templateUrl: './widget-stats.component.html',
  styleUrls: ['./widget-stats.component.scss']
})
export class WidgetStatsComponent {
  @Input() data:any=null
  @Input() isLoading: boolean = false;
  @Input() source: string = "";

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    // Update tooltip position on scroll
    this.updateTooltipPosition();
  }
  tooltipPositionClass: string = 'tooltip-top';
  constructor(
    private elementRef: ElementRef,
  ) {}

  updateTooltipPosition(): void {
    const element = this.elementRef.nativeElement.querySelector('.tooltip');
    if (!element) return;

    // Get the element's position relative to the viewport
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    // Calculate scroll percentage
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - viewportHeight;
    const scrollPercentage = documentHeight > 0 ? (scrollTop / documentHeight) * 100 : 0;

    // Determine tooltip position based on element position and scroll percentage
    let position = 'tooltip-top'; // Default position

    // Element position checks
    const spaceAbove = rect.top;
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceLeft = rect.left;
    const spaceRight = viewportWidth - rect.right;

    // Scroll percentage thresholds (adjust as needed)
    const isTopHalf = scrollPercentage < 50;
    const isBottomHalf = scrollPercentage >= 50;

    // Logic to determine the best position
    if (isTopHalf) {
      // If in the top half of the page, prefer bottom or right/left
      if (spaceBelow > spaceAbove && spaceBelow > 100) {
        position = 'tooltip-bottom'; // Enough space below
      } else if (spaceRight > spaceLeft && spaceRight > 100) {
        position = 'tooltip-right'; // Enough space to the right
      } else if (spaceLeft > 100) {
        position = 'tooltip-left'; // Enough space to the left
      } else {
        position = 'tooltip-top'; // Fallback to top
      }
    } else if (isBottomHalf) {
      // If in the bottom half of the page, prefer top or right/left
      if (spaceAbove > spaceBelow && spaceAbove > 100) {
        position = 'tooltip-top'; // Enough space above
      } else if (spaceRight > spaceLeft && spaceRight > 100) {
        position = 'tooltip-right'; // Enough space to the right
      } else if (spaceLeft > 100) {
        position = 'tooltip-left'; // Enough space to the left
      } else {
        position = 'tooltip-bottom'; // Fallback to bottom
      }
    }

    // Update the tooltip position class
    this.tooltipPositionClass = position;
  }

  resetTooltipPosition(): void {
    // Optionally reset to default position when not hovering
    this.tooltipPositionClass = 'tooltip-top';
  }
  isTooltipVisible: boolean = false;
}
